module.exports = __webpack_public_path__ + "img/zh8.0a48cb37.png";